import { CompanyAPI } from '@api';

const getDebitNote = (initialDate) => {
  const params = {
    initialDate,
  };

  return CompanyAPI.getDebitNote(params)
    .then(({ data }) => data)
    .catch((error) => Promise.reject(error.response));
};

export { getDebitNote };
